/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountCustomerTeamContextDetailsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountCustomerTeamContextDetailsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly customerTeamContext: { readonly __typename?: 'CustomerTeamContext', readonly details: Record<string, any> | null } | null } | null };


export const AccountCustomerTeamContextDetailsDocument = gql`
    query AccountCustomerTeamContextDetails($accountId: AccountId!) {
  account(id: $accountId) {
    id
    customerTeamContext {
      details
    }
  }
}
    `;

/**
 * __useAccountCustomerTeamContextDetailsQuery__
 *
 * To run a query within a React component, call `useAccountCustomerTeamContextDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCustomerTeamContextDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCustomerTeamContextDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountCustomerTeamContextDetailsQuery(baseOptions: Apollo.QueryHookOptions<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables> & ({ variables: AccountCustomerTeamContextDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>(AccountCustomerTeamContextDetailsDocument, options);
      }
export function useAccountCustomerTeamContextDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>(AccountCustomerTeamContextDetailsDocument, options);
        }
export function useAccountCustomerTeamContextDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>(AccountCustomerTeamContextDetailsDocument, options);
        }
export type AccountCustomerTeamContextDetailsQueryHookResult = ReturnType<typeof useAccountCustomerTeamContextDetailsQuery>;
export type AccountCustomerTeamContextDetailsLazyQueryHookResult = ReturnType<typeof useAccountCustomerTeamContextDetailsLazyQuery>;
export type AccountCustomerTeamContextDetailsSuspenseQueryHookResult = ReturnType<typeof useAccountCustomerTeamContextDetailsSuspenseQuery>;
export type AccountCustomerTeamContextDetailsQueryResult = Apollo.QueryResult<AccountCustomerTeamContextDetailsQuery, AccountCustomerTeamContextDetailsQueryVariables>;